import { css } from '@/styled-system/css';

export const seoFooter = css({
  paddingTop: 'loose',
  paddingBottom: 'loose',
});

export const groupGrid = css({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: 'loose',
  alignItems: 'start',
  lg: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
});

export const group = css({
  borderTopWidth: 'default',
  borderTopStyle: 'solid',
  borderTopColor: 'border.neutral',
  paddingTop: 'tighter',
  '&:first-of-type': {
    borderTopWidth: 0,
    paddingTop: 0,
  },
  lg: {
    borderTopWidth: 0,
    paddingTop: 0,
  },
});

export const groupSummary = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 'default',
  cursor: 'pointer',
  listStyle: 'none',
  padding: 0,
  fontSize: 'body',
  lineHeight: 'body',
  fontWeight: 'bold',
  color: 'text.neutral',
  '&::-webkit-details-marker': {
    display: 'none',
  },
  '&::marker': {
    content: '""',
  },
  _focusVisible: {
    outlineWidth: 'thick',
    outlineStyle: 'solid',
    outlineColor: 'border.accent.brand.hero',
    outlineOffset: '50',
    borderRadius: 'sm',
  },
  lg: {
    cursor: 'default',
    pointerEvents: 'none',
  },
});

export const caret = css({
  flexShrink: 0,
  color: 'text.neutral',
  transitionProperty: 'transform',
  transitionDuration: '200ms',
  transitionTimingFunction: 'ease',
  'details[open] &': {
    transform: 'rotate(180deg)',
  },
  '@media (prefers-reduced-motion: reduce)': {
    transitionDuration: '0ms',
  },
  lg: {
    display: 'none',
  },
});

export const linkList = css({
  display: 'flex',
  flexDirection: 'column',
  listStyle: 'none',
  padding: 0,
  margin: 0,
  marginTop: 'tighter',
  gap: 'tightest',
});

export const linkItem = css({
  fontSize: 'body-sm',
  lineHeight: 'heading-sm',
});
